if(!window.routes){
  window.routes = {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    predictive_search_url: '/search/suggest',
  };
}
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        // $('#satcb_quantity').remove();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var cart_add_url = routes.cart_add_url;
        var formData = new FormData(this.form),
            $this = this;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          config.body = formData;
        }
        fetch(cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            GA4.add_to_cart(response);

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;
  return [day, month, year].join('/');
}

function calculateEstimatedDelivery() {
  var cutOffTime = 12;
  var aestTime = new Date().toLocaleString("en-US", {timeZone: "Australia/Sydney"});
  var currentDate = new Date(aestTime);
  var currentHour = currentDate.getHours();
  var HolidayList = ["05/10/2026","25/12/2026","26/12/2026","28/12/2026","01/01/2027","26/01/2027"];
  //DD/MM/YYYY

  if(currentHour > cutOffTime - 1){
    currentDate.setDate(currentDate.getDate() + 1);
  }
  var dispatchDate = new Date(currentDate);
  var currentDay = currentDate.getDay();

  if(currentDay > 0 && currentDay < 6){
    dispatchDate = new Date(currentDate);
  }else if(currentDay == 6){
    dispatchDate.setDate(dispatchDate.getDate() + 2);
  }else if(currentDay == 0){
    dispatchDate.setDate(dispatchDate.getDate() + 1);
  }

  var dispatchDay = dispatchDate.getDay();
  var deliveryDate = new Date(dispatchDate);
  deliveryDate.setDate(dispatchDate.getDate() + 2);

  if(dispatchDay == 4){
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  } else if(dispatchDay == 5){
    deliveryDate.setDate(deliveryDate.getDate() + 2);
  }

  for(i=0; i < HolidayList.length; i++){
    var holiday = HolidayList[i];
    var dateFrom = formatDate(dispatchDate);
    var dateTo = formatDate(deliveryDate);

    var d1 = dateFrom.split("/");
    var d2 = dateTo.split("/");
    var c = holiday.split("/");

    var from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
    var to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
    var check = new Date(c[2], parseInt(c[1])-1, c[0]);

    if(check >= from && check <= to){
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    var deliveryDay = deliveryDate.getDay();
    if(deliveryDay == 6){
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    }else if(deliveryDay == 0){
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
  }
  var month = deliveryDate.toLocaleString('default', { month: 'short' });

  var nthNumber = (number) => {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  var date = `${deliveryDate.getDate()}${nthNumber(deliveryDate.getDate())} ${month}`;
  return date;
}

if(document.getElementById('delivery-date')){
  document.getElementById('delivery-date').innerHTML = calculateEstimatedDelivery();
  document.querySelectorAll('.expected-delivery').forEach(function(el){ el.style.display = 'flex'; });
}

window.Shopify.uniq = function(t) {
  for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
  return e
}
Shopify.arrayIncludes = function(t, e) {
  for (var o = 0; o < t.length; o++)
      if (t[o] == e) return !0;
  return !1
}

window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  var selects = document.querySelectorAll(parent + ' .product-form__input .select__select');
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = selects[0] ? selects[0].value : '';
      break;
    case 2:
      var key = selects[0] ? selects[0].value : '';
      key += ` / ${selects[1] ? selects[1].value : ''}`;
  }
  var availableOptions = Shopify.optionsMap[key];
  if(key != "root"){
    availableOptions = window.Shopify.changeorder(availableOptions,key);
  // console.log("key",key);
  // console.log("availableOptions",availableOptions);
  }
  var selector = selects[selectorIndex];
  var initialValue = selector ? selector.value : '';
  if(!document.querySelector('.variant-v2')){
    if(selector) selector.innerHTML = '';
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = document.createElement('option');
      newOption.value = option;
      newOption.innerHTML = option;
      if(selector) selector.appendChild(newOption);
    }
    if (availableOptions.includes(initialValue)) {
      selector.value = initialValue;
    }
    if(selector) selector.dispatchEvent(new Event('change', {bubbles: true}));
  }
};

window.Shopify.updateOptionsInSelectorRadio = function (selectorIndex, parent) {
  var fieldsets = document.querySelectorAll(parent + ' fieldset');
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var checked0 = fieldsets[0] ? fieldsets[0].querySelector('input:checked') : null;
      var key = checked0 ? checked0.value : '';
      break;
    case 2:
      var checked0 = fieldsets[0] ? fieldsets[0].querySelector('input:checked') : null;
      var checked1 = fieldsets[1] ? fieldsets[1].querySelector('input:checked') : null;
      var key = checked0 ? checked0.value : '';
      key += ` / ${checked1 ? checked1.value : ''}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  var selector = fieldsets[selectorIndex];
  var $product = window.productJSONData;
  if(!selector) return;
  selector.querySelectorAll("label").forEach(function(l){ l.classList.remove("v-available"); });
  selector.querySelectorAll("label").forEach(function(l){ l.classList.add("v-unavailable"); });
  for (var i=0; i<availableOptions.length; i++) {
    var option = availableOptions[i];
    // console.log(option,selector.querySelectorAll("input[value='"+option+"']+label").length);
    selector.querySelectorAll(`input[value="${option}"]+label`).forEach(function(l){ l.classList.add("v-available"); });
    selector.querySelectorAll(`input[value="${option}"]+label`).forEach(function(l){ l.classList.remove("v-unavailable"); });
    if(selectorIndex == 1){
      for(j=0; j< $product.variants.length; j++){
        $variant = $product.variants[j];
        if($variant.option1 == key && $variant.option2 == option){
          var $imgBase = $variant.featured_image ? $variant.featured_image.src : $product.featured_image;
          var $img = $imgBase + '&width=200';
          var $imgSrcset = $imgBase + '&width=100 100w, ' + $imgBase + '&width=200 200w';
          var $imgAlt = $product.title + ' ' + $variant.title;
          selector.querySelectorAll(`input[value="${option}"]+label .swatch-flavour-img`).forEach(function(el){
            var swatchImg = el.querySelector('img');
            if(swatchImg){
              swatchImg.src = $img;
              swatchImg.srcset = $imgSrcset;
              swatchImg.alt = $imgAlt;
            }else{
              el.innerHTML = `<img src="${$img}" srcset="${$imgSrcset}" sizes="100px" loading="lazy" alt="${$imgAlt}">`;
            }
          });
        }
      }
    }
  }
  // if(selector.querySelector("input:checked+label.v-available") == null){ }
  // selector.querySelector(".v-available").click();
  setTimeout(function(){
    var checkedInput = selector.querySelector("input:checked");
    if(checkedInput && checkedInput.classList.contains('disabled')){
      var firstNotDisabled = selector.querySelector("input:not(.disabled)");
      if(firstNotDisabled) firstNotDisabled.click();
    }
  },100);
  document.querySelectorAll('.variant-v2 variant-radios .product-form__input').forEach(function(el){
    var $length = el.querySelectorAll('.v2-swatch-wrapper .v-available').length;
    var optSize = el.querySelector('.option-size');
    if(optSize) optSize.innerHTML = $length + ' options';
  });
};

window.Shopify.changeorder = function(options,key){
  // console.log("options",options)
  // console.log("key",key)
  var $movebottomlist = "";
  if(window.pre_order_options){
    var $pre_order_or_soldout = window.pre_order_options.split(',');
    var $movebottomlist = $pre_order_or_soldout.filter(entry => entry.startsWith(key)).map(entry => {
      const parts = entry.split('/');
      return parts[1]?.trim();
    });
  }
  // console.log("$movebottomlist",$movebottomlist)

  if($movebottomlist.length){
    const moveToBottom = $movebottomlist;
    const isTargetOption = (option) =>  moveToBottom.some(target => option.toLowerCase().includes(target.toLowerCase()));

    const bottomOptions = options.filter(isTargetOption);
    const otherOptions = options.filter(option => !isTargetOption(option));

    const reorderedOptions = [...otherOptions, ...bottomOptions];
    // console.log("reorderedOptions",reorderedOptions)
    return reorderedOptions;
  }else{
    return options;
  }
}

window.Shopify.linkOptionSelectors = function (product, parent) {
  // console.log('INININININI')
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // window.Shopify.optionsMap.root = window.Shopify.changeorder(window.Shopify.optionsMap.root,window.Shopify.optionsMap.root)
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
        // window.Shopify.optionsMap[key] = window.Shopify.changeorder(window.Shopify.optionsMap[key],key);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
        // window.Shopify.optionsMap[key] = window.Shopify.changeorder(window.Shopify.optionsMap[key],key);
      }
    }
  }

  // When there is an update in the first dropdown.
  if(document.querySelector('.variant-v2')){
    window.Shopify.updateOptionsInSelectorRadio(0, parent);
    if (product.options.length > 1) window.Shopify.updateOptionsInSelectorRadio(1, parent);
    var fieldsets = document.querySelectorAll(parent + ' fieldset');
    if(fieldsets[0]){
      fieldsets[0].querySelectorAll('input[type=radio]').forEach(function(r){
        r.addEventListener('change', function(){
          if (product.options.length === 2) window.Shopify.updateOptionsInSelectorRadio(1, parent);
        });
      });
    }
  }else{
    // Update options right away.
    window.Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);

    var selects = document.querySelectorAll(parent + ' .product-form__input .select__select');
    if(selects[0]){
      selects[0].addEventListener('change', function(){
        if (product.options.length === 2) window.Shopify.updateOptionsInSelector(1, parent);
        if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
      });
    }
    // When there is an update in the second dropdown.
    if(selects[1]){
      selects[1].addEventListener('change', function(){
        if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
      });
    }
  }
  // console.log("parent",parent);
  // if(window.trigger_first_option){
  //   const parentElement = document.querySelector(parent);
  //   if(parentElement){
  //     const selectElement = parentElement.querySelectorAll('.product-form__input .select__select')[1];
  //     if (selectElement) {
  //       const firstOptionValue = selectElement.querySelector('option')?.value;
  //       if (firstOptionValue) {
  //         selectElement.value = firstOptionValue;
  //         const event = new Event('change', { bubbles: true });
  //         selectElement.dispatchEvent(event);
  //       }
  //     }
  //   }else{
  //     selects[1].value = selects[1].querySelector('option')?.value;
  //     selects[1].dispatchEvent(new Event('change', {bubbles: true}));
  //   }
  // }
};

// document.querySelectorAll('.product__info-wrapper-last-column').forEach(function(el){
// document.querySelectorAll('.product__info-wrapper-last-column, .product__info-wrapper-apparel').forEach(function(el) {
//   // return;
//   var infoContainer = el.querySelector('.product__info-container');
//   if(infoContainer && infoContainer.dataset.handle){
//     setTimeout(function(){
//       var Handle = infoContainer.dataset.handle;
//       var JSONData = JSON.parse(document.getElementById("product-" + Handle).innerHTML);
//       window.productJSONData = JSONData;
//       var variantSelects = document.querySelector('.product__info-wrapper-last-column .product__info-container[data-handle="'+Handle+'"] variant-selects');
//       var $id = variantSelects ? variantSelects.id : null;
//       if(document.querySelector('.variant-v2')){
//         Shopify.linkOptionSelectors(JSONData, '.product__info-wrapper-last-column .product__info-container[data-handle="'+Handle+'"] variant-radios');
//       }else{
//         if($id){
//           Shopify.linkOptionSelectors(JSONData, '#'+$id);
//         }else{
//           Shopify.linkOptionSelectors(JSONData, '.product__info-wrapper-last-column .product__info-container[data-handle="'+Handle+'"] variant-selects');
//         }
//       }
//     },1000);
//   }
// });

document.querySelectorAll('.product__info-wrapper-last-column, .product__info-wrapper-apparel').forEach(function(el) {
  var infoContainer = el.querySelector('.product__info-container');

  if (infoContainer && infoContainer.dataset.handle) {
    setTimeout(function() {
      var Handle = infoContainer.dataset.handle;
      var JSONData = JSON.parse(document.getElementById("product-" + Handle).innerHTML);
      window.productJSONData = JSONData;

      var wrapperClass = el.classList.contains('product__info-wrapper-apparel')
        ? '.product__info-wrapper-apparel'
        : '.product__info-wrapper-last-column';

      var variantSelects = document.querySelector(wrapperClass + ' .product__info-container[data-handle="' + Handle + '"] variant-selects');
      var $id = variantSelects ? variantSelects.id : null;

      if (el.querySelector('.variant-v2')) {
        Shopify.linkOptionSelectors(JSONData, wrapperClass + ' .product__info-container[data-handle="' + Handle + '"] variant-radios');
      } else {
        if ($id) {
          Shopify.linkOptionSelectors(JSONData, '#' + $id);
        } else {
          Shopify.linkOptionSelectors(JSONData, wrapperClass + ' .product__info-container[data-handle="' + Handle + '"] variant-selects');
        }
      }
    }, 1000);
  }
});

document.querySelectorAll('.quantity-pack input[type=radio]').forEach(function(radio){
  radio.addEventListener('change', function(){
    document.querySelectorAll('.quantity-pack').forEach(function(el){ el.classList.remove('active'); });
    radio.parentElement.classList.add('active');
  });
});

if(window.location.pathname != "/products/mystery-product-stack" && window.location.pathname != "/products/per4m" && window.location.pathname != "/products/100-whey-protein"){
  var wrapper_v3 = document.querySelector('.flavour-type-variant-wrapper .v2-swatch-wrapper');
  if(wrapper_v3){
    const children = Array.from(wrapper_v3.children);
    const pairs = [];

    for (let i = 0; i < children.length; i += 2) {
      const input = children[i];
      const label = children[i + 1];
      if (input && label && label.tagName === 'LABEL') {
        const text = label.textContent.trim().toLowerCase();
        pairs.push({ input, label, text });
      }
    }

    pairs.sort((a, b) => a.text.localeCompare(b.text));

    wrapper_v3.innerHTML = '';
    pairs.forEach(pair => {
      wrapper_v3.appendChild(pair.input);
      wrapper_v3.appendChild(pair.label);
    });
  }
}

document.querySelectorAll('.mystery-product-selection .flavour-type-variant-wrapper input[type=radio]').forEach(function(radio){
  radio.addEventListener('change', function(){
    var $p_total = 0;
    var $c_total = 0;
    document.querySelectorAll('.mystery-product-selection .flavour-type-variant-wrapper').forEach(function(wrapper){
      var checked = wrapper.querySelector('input[type=radio]:checked');
      if(checked){
        $p_total += parseInt(checked.dataset.price);
        $c_total += parseInt(checked.dataset.cprice);
      }
    });
    var customPrice = document.querySelector('.custom-price');
    if(customPrice) customPrice.innerHTML = Shopify.formatMoney($p_total, Shopify.money_format);
    var priceSale = document.querySelector('.price__container .price-item--sale');
    if(priceSale) priceSale.innerHTML = Shopify.formatMoney($p_total, Shopify.money_format);
    var priceRegular = document.querySelector('.price__container .price-item--regular');
    if(priceRegular) priceRegular.innerHTML = Shopify.formatMoney($c_total, Shopify.money_format);
    var discount = Math.round((1 - ($p_total / $c_total)) * 100);
    var badgeSale = document.querySelector('.price__badge-sale');
    if(badgeSale) badgeSale.innerHTML = discount + '% OFF';
  });
});

// $(document).on("change", ".bundle-variants select", function(){
//   var $parent = $(this).parents('.bundle-variants');
//   var $sku = "";
//   $parent.find('select').each(function(){
//     $sku +=$(this).find('option:selected').data('sku')+',';
//   });
//   $('#sis-bundle').attr('sis-upi',$sku);
//   if(typeof(stockInStore)=="object"){
//     stockInStore.updateCNCStatus({'index_type': 'upi', 'index_value': $sku}, true)
//   }
// });
